<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">ตั้งเรท{{ name_alert }}เรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">

        <v-card class="mb-3 pa-3" v-for="(detail,index) in data" :key="index">
            <div class="d-flex align-center justify-space-between">
                <h2>ตั้งเรท {{ detail.name }}</h2>
                <div>อัพเดทล่าสุด โดย {{ detail.user_name }} {{ detail.date }}</div>
            </div>

            <div class="d-flex align-center">
                <div>ชั่วโมงล่ะ</div>
                <div class="mx-1">
                    <v-text-field :label="`เรท ${detail.name}`" type="number" v-model="detail.rate" @keyup="editPartTimeOT(detail.id,detail.name)" hide-details="auto" required outlined></v-text-field>
                </div>
                <div>บาท</div>
            </div>
        </v-card>
    </div>
</div>
</template>

<script>
import parttimeot from '@/api/team/teamsetting/parttimeot.js'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            name_alert: null,
            data: [],
        }
    },
    methods: {
        async partTimeOTList() {
            parttimeot.partTimeOTList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.rate
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async editPartTimeOT(id, name) {
            this.name_alert = name
            this.alert_show = false
            const data = this.data.find((detail) => {
                return detail.id == id
            })
            parttimeot.editPartTimeOT(id, data).then((response) => {
                if (response.data.successful === true) {
                    this.partTimeOTList()
                    this.alert_show = true
                    setTimeout(() => this.alert_show = false, 5000)
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
    },
    mounted() {
        this.partTimeOTList()
    }
}
</script>
